import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const scrollToTop = () => {
      // Scroll usando metodi nativi
      document.body.scrollTop = 0; // Safari
      document.documentElement.scrollTop = 0; // Chrome, Firefox
      window.scrollTo({ top: 0, behavior: 'instant' });
    };

    // Scroll immediato
    scrollToTop();

    // Fallback per browser lenti
    const timeout = setTimeout(scrollToTop, 50);

    return () => clearTimeout(timeout);
  }, [pathname]);

  return null;
};

export default ScrollToTop;
